import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import { enabledSelector, newPathSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import { getContent } from '../selectors/simpleSelectors';
import Icon from '../../common/containers/icon';
const BehaviorButton = _ref => {
  let actions = _ref.actions,
    enabled = _ref.enabled,
    path = _ref.path,
    title = _ref.title,
    _ref$webIcon = _ref.webIcon,
    webIcon = _ref$webIcon === void 0 ? null : _ref$webIcon,
    handleActions = _ref.formActions.handleActions,
    pendingOperation = _ref.pendingOperation,
    info = _ref.notificationActions.info,
    reduxEntity = _ref.reduxEntity,
    _ref$variables = _ref.variables,
    variables = _ref$variables === void 0 ? {} : _ref$variables;
  const classNames = useMemo(() => classnames('tqc-control', 't-rb-add-button', "t-bb-".concat(kebabCase(title))), [title]);
  const handlePress = async () => {
    // make sure blue events in other inputs happen first.
    if (pendingOperation) {
      info({
        message: 'Waiting for changes to save.'
      }, {
        autoClose: 3000
      });
    } else {
      // The request is passed through formActions for all entity types since they all use
      // contentChangeActionFactory.handleActions
      await handleActions(reduxEntity, actions, path, variables);
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    disabled: !enabled,
    block: true,
    onClick: handlePress,
    className: classNames
  }, webIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    glyph: webIcon
  }), "\xA0") : null, title);
};
BehaviorButton.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  content: PropTypes.shape({}),
  enabled: PropTypes.bool.isRequired,
  formActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  initialContent: PropTypes.shape({}),
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired,
  path: PropTypes.string.isRequired,
  pendingOperation: PropTypes.bool.isRequired,
  reduxEntity: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  webIcon: PropTypes.string,
  variables: PropTypes.shape({})
};
export { BehaviorButton as UncomposedBehaviorButton };
export default entityComposition(BehaviorButton, [], {
  enabled: enabledSelector,
  path: newPathSelector,
  content: getContent,
  pendingOperation: state => state.form.pendingOperation
}, ['form', 'notification']);